<div *ngIf="!loadingForGrantAccess; else loadingForGrantAccessTemplate" class="login-wrapper">
  <div class="login-wallpaper">
    <img *ngIf="backgroundImagePath" class="app-background" [src]="backgroundImagePath">
  </div>
  <div class="login-container">
    <div class="login-header p-t-35" *ngIf="!logoImagePath">
      <eidos-icon id="mainLogo" class="app-logo" [iconConfiguration]="logo"></eidos-icon>
      <!--<a *ngIf="!loggingIn" class="register-credential" (click)="registerCredentials()">Get your access</a>-->
    </div>
    <div class="login-header p-t-35" *ngIf="logoImagePath">
      <img id="mainLogo" class="app-logo" src="{{logoImagePath}}">
      <!--<a *ngIf="!loggingIn" class="register-credential" (click)="registerCredentials()">Get your access</a>-->
    </div>
    <div class="login-header">
      <label class="login-error" *ngIf="serverError">{{serverError}}</label>
    </div>
    <div class="mat-card auth-block">
      <div class="mat-card-content">
        <form [formGroup]="loginForm" (ngSubmit)="formAuthentication()" (capsLockActive)="toggleCapsLock($event)">
          <div class="field full-width-input">
            <input type="text" placeholder="Username" formControlName="username" required>
            <span class="field-error" *ngIf="loginForm.controls.username.invalid && loginForm.controls.username.touched">
              Please provide a valid username
            </span>
          </div>
          <div class="field full-width-input">
            <input type="password" placeholder="Password" formControlName="password" required>
            <span class="field-error" *ngIf="loginForm.controls.password.invalid && loginForm.controls.password.touched">
              Please provide a valid password
            </span>
          </div>
          <label class="caps-lock-message" *ngIf="capsLockActive">CAPS LOCK is active</label>
          <button *ngIf="!loggingIn" class="eidos-button eidos-button-normal login-btn-primary">Login</button>
          <eidos-progress-spinner *ngIf="loggingIn === EidosAuthType.Form" [diameter]="20" style="margin: 0 auto;"></eidos-progress-spinner>
          <!--<a *ngIf="!loggingIn" class="password-reset-message" (click)="resetCredentials()">Lost your credentials?</a>-->
        </form>
      </div>
    </div>
    <div *ngIf="windowsAuthEnabled">
      <div class="mat-card auth-block">
        <div class="mat-card-content">
          <img class="login-image" src="assets/images/windows.png"><br />
          <button *ngIf="!loggingIn" class="eidos-button eidos-button-normal login-btn-primary" (click)="windowsAuthentication()">Login</button>
          <eidos-progress-spinner *ngIf="loggingIn === EidosAuthType.Windows" [diameter]="20" style="margin: 0 auto;"></eidos-progress-spinner>
        </div>
      </div>
    </div>
    <div *ngIf="microsoftAuthEnabled">
      <div class="mat-card auth-block">
        <div class="mat-card-content">
          <img class="login-image" src="assets/images/microsoft-id.png"><br />
          <button *ngIf="!loggingIn" class="eidos-button eidos-button-normal login-btn-primary" (click)="oAuth2Authentication(EidosAuthType.Microsoft)">Login</button>
          <eidos-progress-spinner *ngIf="loggingIn === EidosAuthType.Microsoft" [diameter]="20" style="margin: 0 auto;"></eidos-progress-spinner>
        </div>
      </div>
    </div>
    <div *ngIf="googleAuthEnabled">
      <div class="mat-card auth-block">
        <div class="mat-card-content">
          <img class="login-image" src="assets/images/google.png"><br />
          <button *ngIf="!loggingIn" class="eidos-button eidos-button-normal login-btn-primary" (click)="oAuth2Authentication(EidosAuthType.Google)">Login</button>
          <eidos-progress-spinner *ngIf="loggingIn === EidosAuthType.Microsoft" [diameter]="20" style="margin: 0 auto;"></eidos-progress-spinner>
        </div>
      </div>
    </div>
  </div>

  <div class="login-container-mobile">
    <div class="login-header">
      <eidos-icon id="mainLogo" class="app-logo-mobile" [iconConfiguration]="logo"></eidos-icon>
      <!--<a *ngIf="!loggingIn" class="register-credential" (click)="registerCredentials()">Get your access</a>-->
    </div>
    <div class="login-header">
      <label class="login-error" *ngIf="serverError">{{serverError}}</label>
    </div>
    <div class="mat-card auth-block">
      <div class="mat-card-content">
        <form [formGroup]="loginForm" (ngSubmit)="formAuthentication()" (capsLockActive)="toggleCapsLock($event)">
          <div class="field full-width-input">
            <input type="text" placeholder="Username" formControlName="username" required>
            <span class="field-error" *ngIf="loginForm.controls.username.invalid && loginForm.controls.username.touched">
              Please provide a valid username
            </span>
          </div>
          <div class="field full-width-input">
            <input type="password" placeholder="Password" formControlName="password" required>
            <span class="field-error" *ngIf="loginForm.controls.password.invalid && loginForm.controls.password.touched">
              Please provide a valid password
            </span>
          </div>
          <label class="caps-lock-message" *ngIf="capsLockActive">CAPS LOCK is active</label>
          <button *ngIf="!loggingIn" class="login-button eidos-button eidos-button-normal login-btn-primary" type="submit">Login</button>
          <eidos-progress-spinner *ngIf="loggingIn === EidosAuthType.Form" [diameter]="20" style="margin: 0 auto;"></eidos-progress-spinner>
          <!--<a *ngIf="!loggingIn" class="password-reset-message" (click)="resetCredentials()">Lost your credentials?</a>-->
        </form>
      </div>
    </div>
    <div *ngIf="windowsAuthEnabled">
      <div class="mat-card auth-block">
        <div class="mat-card-content">
          <img class="login-image" src="assets/images/windows.png"><br />
          <button *ngIf="!loggingIn" class="eidos-button eidos-button-normal login-btn-primary" (click)="windowsAuthentication()">Login</button>
          <eidos-progress-spinner *ngIf="loggingIn === EidosAuthType.Windows" [diameter]="20" style="margin: 0 auto;"></eidos-progress-spinner>
        </div>
      </div>
    </div>
    <div *ngIf="microsoftAuthEnabled">
      <div class="mat-card auth-block">
        <div class="mat-card-content">
          <img class="login-image" src="assets/images/microsoft-id.png"><br />
          <button *ngIf="!loggingIn" class="eidos-button eidos-button-normal login-btn-primary" (click)="oAuth2Authentication(EidosAuthType.Microsoft)">Login</button>
          <eidos-progress-spinner *ngIf="loggingIn === EidosAuthType.Microsoft" [diameter]="20" style="margin: 0 auto;"></eidos-progress-spinner>
        </div>
      </div>
    </div>
    <div *ngIf="googleAuthEnabled">
      <div class="mat-card auth-block">
        <div class="mat-card-content">
          <img class="login-image" src="assets/images/google.png"><br />
          <button *ngIf="!loggingIn" class="eidos-button eidos-button-normal login-btn-primary" (click)="oAuth2Authentication(EidosAuthType.Google)">Login</button>
          <eidos-progress-spinner *ngIf="loggingIn === EidosAuthType.Microsoft" [diameter]="20" style="margin: 0 auto;"></eidos-progress-spinner>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #loadingForGrantAccessTemplate>
  <div class="redirection-waiting">
    <h1>Waiting for redirection to home page....</h1>
    <div class="my-3">
      <eidos-progress-spinner [diameter]="50"></eidos-progress-spinner>
    </div>
  </div>
</ng-template>
